import { BarChart } from "@mui/x-charts";
import { t } from "i18next";
import { useEffect, useState } from "react";

const TaskBarChart = ({ dataBar, labelChart }) => {
  const [dataLabel, setDataLabel] = useState([]);
  const [dataObj, setDataObj] = useState({});

  useEffect(() => {
    if (dataBar && dataBar?.labels) {
      setDataLabel(dataBar?.labels);
    }
  }, [dataBar, dataBar?.labels]);

  useEffect(() => {
    if (dataBar && dataBar?.objects) {
      setDataObj(dataBar?.objects);
    }
  }, [dataBar, dataBar?.objects]);

  const dataSetBar = dataLabel.map((label, idx) => {
    const dato = dataObj?.find((item) => item.name === label);
    return dato ? dato : { label, value: 0 };
  });

  const availableKeys = Object.keys(dataSetBar[0] || {});

  const allSeries = [
    {
      dataKey: "value1",
      label: "Attività Aperta",
      color: "#C1272D",
      bar: "Stato Attività",
    },
    {
      dataKey: "value2",
      label: "Attività Chiusa",
      color: "#359F1C",
      bar: "Stato Attività",
    },
    {
      dataKey: "value1",
      label: "Attività Aperta",
      color: "#C1272D",
      bar: "Capacità Operativa",
    },
    {
      dataKey: "value2",
      label: "In Lavorazione",
      color: "#d8b207",
      bar: "Capacità Operativa",
    },
    {
      dataKey: "value1",
      label: "Effort Stimato",
      color: "#9572a2",
      bar: "Analisi Effort",
    },
    {
      dataKey: "value2",
      label: "Effort Effettivo",
      color: "#7f7f7f",
      bar: "Analisi Effort",
    },
  ];

  const filteredSeries = allSeries.filter(
    (series) =>
      availableKeys.includes(series.dataKey) && series.bar === labelChart
  );

  return (
    <div>
      <p className="text-2xl font-bold m-0 ">
        Riepilogo: <span className="text-primary">{labelChart}</span>
      </p>
      <div className=" w-full flex justify-center">
        <BarChart
          borderRadius={50}
          dataset={dataSetBar}
          xAxis={[
            {
              data: dataLabel.map((label) => t(label)),
              scaleType: "band",
              categoryGapRatio: 0.5,
            },
          ]}
          series={filteredSeries}
          height={600}
        />
      </div>
    </div>
  );
};

export default TaskBarChart;
